<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">ISSUES MASTER</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  text color="grey"
                    @click.prevent="addDoc()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn  text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <div>

                <v-layout column>
                    <v-flex>
                        <v-layout row class="row-header">
                            <v-flex xs4 md4 class="col-header">Issue</v-flex>
                            <v-flex xs3 md3 class="col-header">Issue Type</v-flex>
                            <v-flex xs2 md3 class="col-header">Issue Subtype</v-flex>
                            <v-flex xs1 md1 class="col-header">Idx</v-flex>
                            <v-flex xs2 md1 v-if="updateMode != ''" class="col-header"></v-flex>

                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout v-if="updateMode == 'add'" row>
                            <v-flex xs4 md4>
                                <v-text-field  class="mr-2"
                                    v-model="newDoc.issue"
                                ></v-text-field>
                            </v-flex>
                            
							<v-flex xs3 md3>
                                <v-select  class="mr-2"
                                    :items="issueTypes"
                                    item-text="issueType"
                                    v-model="newDoc.issueType"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.issueType }}
                                    </template>

                                </v-select>                                       
                            </v-flex>

							<v-flex xs3 md3>
                                <v-select  class="mr-2"
                                    :items="issueSubtypes"
                                    item-text="subType"
                                    v-model="newDoc.issueSubtype"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.subType }}
                                    </template>

                                </v-select>                                       
                            </v-flex>
							
                            <v-flex xs1 md1>
                                <v-text-field
                                    v-model="newDoc.idx"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs1 md1>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark x-small color="pink" fab  class="mr-2"
                                            @click.prevent="saveAdd()">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark x-small color="pink" fab  
                                            @click.prevent="cancelAdd()">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                    </v-flex>
                    <v-flex v-for="(doc,i) in docs" :key="i">

                        <v-layout v-if="updateMode == 'edit' && doc.active" row>
                            <v-flex xs4 md4>
                                <v-text-field class="mr-2"
                                    v-model="activeDoc.issue"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3 md3>
                                <v-select  class="mr-2"
                                    :items="issueTypes"
                                    item-text="issueType"
                                    v-model="activeDoc.issueType"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.issueType }}
                                    </template>

                                </v-select>                                       
                            </v-flex>

							<v-flex xs2 md3>
                                <v-select  class="mr-2"
                                    :items="issueSubtypes"
                                    item-text="subType"
                                    v-model="activeDoc.issueSubtype"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.subType }}
                                    </template>

                                </v-select>                                       
                            </v-flex>

                            <v-flex xs1 md1>
                                <v-text-field
                                    v-model="activeDoc.idx"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 md1>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  class="mr-2"
                                            @click.prevent="saveUpdate(doc)">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  
                                            @click.prevent="cancelUpdate(doc)">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                        <v-layout v-else row>
                            <v-flex xs5 md6 class="doc-key" @click="setUpdateMode(doc)">
                                {{ doc.issue }}
                            </v-flex>
                            <v-flex xs3 md3>
                                {{ doc.issueType }}
                            </v-flex>
                            <v-flex xs2 md2>
                                {{ doc.issueSubtype }}
                            </v-flex>
                            <v-flex xs1 md1>
                                {{ doc.idx }}
                            </v-flex>
                            <v-flex xs2 md1 v-if="updateMode == 'edit'"></v-flex>
                        </v-layout>

                    </v-flex>

                </v-layout>

            </div>

        </v-container>

        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            color="purple"
            size="200"
        ></v-progress-circular>
        </v-overlay>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw},
    data(){
        return {
            drawer:false,
            docs:[],
            activeDoc:null,
            updateMode:'',
            newDoc:{
                issue:'',
                issueType:'',
                issueSubtype:'',
                idx:0
            },
            overlay:false,
        }
    },
    computed:{
        ...mapState(['issueMaster','issueTypes','issueSubtypes','currentUser'])
    },
    methods:{
        ...mapActions(['fetchIssueMaster','setCurrentUser']),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            if (this.drawer){
                this.drawer = false
            }

            this.updateMode = ''
            this.setDocs()

            
        },
        addDoc(){
           
            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }

            this.updateMode = 'add'

        },
        cancelAdd(){
            this.updateMode = ''
            this.newDoc = {
                issue:'',
                issueType:'',
                idx:0
            }
        },
        saveAdd(){

            //console.log("this.newDoc",this.newDoc)
            fb.issueMasterCollection.add({
                issue : this.newDoc.issue,
                hdType:this.currentUser.hdType,
                idx: this.newDoc.idx,
                issueType:this.newDoc.issueType,
				issueSubtype:this.newDoc.issueSubtype,
                creationDate: new Date(),
            })
            .then((docRef)=>{
                console.log("docRef ", docRef);
                if (docRef){
                    
                    this.$store.state.issueMaster.push({
                        id:docRef.id,
                        issue:this.newDoc.issue,
                        hdType:this.currentUser.hdType,
                        issueType:this.newDoc.issueType,
						issueSubtype:this.newDoc.issueSubtype,
                        idx:this.newDoc.idx,
                        creationDate:new Date()
                    })
                    
                    this.docs.push({
                        id:docRef.id,
                        issue:this.newDoc.issue,
                        hdType:this.currentUser.hdType,
                        issueType:this.newDoc.issueType,
						issueSubtype:this.newDoc.issueSubtype,
                        idx:this.newDoc.idx,
                        creationDate:new Date()
                    })
                }
                this.updateMode = ''
            })
            .catch(error=>console.log(error))

        },
        setUpdateMode(doc){

            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }
            this.updateMode = 'edit'
            doc.active = true
            this.activeDoc = {...doc}
        },
        cancelUpdate(doc){
            doc.active = false
            this.updateMode = ''
        },
        saveUpdate(doc){

            fb.issueMasterCollection.doc(doc.id).update({
                issue : this.activeDoc.issue,
                idx: this.activeDoc.idx,
                issueType:this.activeDoc.issueType,
				issueSubtype:this.activeDoc.issueSubtype
            })

            doc.issue = this.activeDoc.issue
            doc.issueType = this.activeDoc.issueType
			doc.issueSubtype = this.activeDoc.issueSubtype
            doc.idx = this.activeDoc.idx

            this.updateMode = ''

        },
        signOut(){

            this.$store.state.departments = []
            this.$store.state.sections = []
            this.$store.state.issueMaster = []
            this.$store.state.issueTypes = []
            this.$store.state.issueSubtypes = []
            this.$store.state.locations = []
            this.$store.state.sections = []
            this.$store.state.assignees = []
            this.$store.state.solutionTypes = []
            this.$store.state.solutions = []
            this.$store.state.solutionMethods = []
            this.$store.state.diagnostics = []
            this.$store.state.diagnosticTypes = []

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },

        setDocs(){

            this.docs = []
            this.overlay = true

            let issueMaster = []
            fb.issueMasterCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(docs=>{
                //console.log("docs",docs)

                docs.forEach(doc=>{
                    const  issue = {
                        id:doc.id,
                        issue:doc.data().issue,
                        hdType:doc.data().hdType,
                        issueType:doc.data().issueType,
                        issueSubtype:doc.data().issueSubtype,
                        idx: doc.data().idx
                    }
                    //console.log("issue",issue)
                    issueMaster.push(issue);
                });
                issueMaster.sort((a,b)=>(a.issue > b.issue) ? 1 : -1);

                console.log('issueMaster',issueMaster);
                this.$store.state.issueMaster = [...issueMaster]

                this.docs = [...issueMaster]

                this.docs.forEach(doc=>{
                    doc.active = false
                })

                this.overlay = false

            })

        },
        async checkDropdownLists(){
            
            if (this.$store.state.issueTypes.length == 0){
                let issueTypes = []
                let b = await fb.issueTypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueTypes.push({
                        id:doc.id,
                        issueType:doc.data().issueType
                    });
                }
                this.$store.state.issueTypes = [...issueTypes]
                //console.log("this.issueTypes",this.$store.state.issueTypes)
            }

            if (this.$store.state.issueSubtypes.length == 0){
                let issueSubtypes = []
                let b = await fb.issueSubtypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueSubtypes.push({
                        id:doc.id,
                        subType:doc.data().subType
                    });
                }
                this.$store.state.issueSubtypes = [...issueSubtypes]
                console.log("this.$store.state.issueSubtypes",this.$store.state.issueSubtypes)
            }

        
        }

    },
    mounted(){

        console.log("Issue Master mounted!");

    },
    created(){
        console.log("Issue Master Created")

        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        this.updateMode = '';

        this.checkDropdownLists()

        if (this.$store.state.issueMaster.length == 0){
            this.setDocs()
        }else{
            this.docs = [...this.$store.state.issueMaster]

            this.docs.forEach(doc=>{
                doc.active = false
            })

        }


    },

}
</script>

<style  scoped>
.doc-key{
    cursor: pointer;
}
.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>